import { useUnlinkConversationFromSubmissionMutation } from "@qw/graphql";
import { Button, Icon, Tooltip, TooltipContent, TooltipTrigger } from "@qw/ui";
import { type FC, useCallback } from "react";

export const UnlinkSubmissionButton: FC<{
  conversationId: string;
  submissionId: string;
}> = ({ conversationId, submissionId }) => {
  const [unlinkConversationFromSubmission] = useUnlinkConversationFromSubmissionMutation({
    refetchQueries: ["InboxConversation"],
  });

  const handleClick = useCallback(async () => {
    await unlinkConversationFromSubmission({ variables: { input: { conversationId, submissionId } } });
  }, [conversationId, submissionId, unlinkConversationFromSubmission]);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="ghost" size="xs" display="icon" className="group/button" onClick={handleClick}>
          <Icon icon="link" className="group-hover/button:hidden" />
          <Icon icon="link_off" className="hidden group-hover/button:inline" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>Unlink Submission</TooltipContent>
    </Tooltip>
  );
};
